<template>
  <div class="auth">
    <div class="auth-container">
      <div class="card card-login">
        <header class="auth-header">
          <h1 class="auth-title">
            <img src="/static/logo-login.png" alt="Volta Analytics" />
          </h1>
        </header>
        <div class="auth-content">
          <form id="login-form" v-on:submit.prevent="login">
            <div class="form-group mb-0">
              <input
                type="text"
                v-model="username"
                class="form-control no-border"
                name="username"
                id="username"
                placeholder="Username"
                required
              />
            </div>
            <div class="form-group">
              <input
                type="password"
                v-model="password"
                class="form-control no-border"
                name="password"
                id="password"
                placeholder="Password"
                required
              />
            </div>

            <p class="alert alert-warning" v-if="message">
              {{ message }}
            </p>

            <div class="form-group">
              <button type="submit" class="btn btn-block btn-brand">
                <font-awesome-icon
                  class="fa-spin"
                  icon="spinner"
                  v-if="loading"
                />
                <span v-if="!loading">Login</span>
              </button>
            </div>
          </form>
          <div>
            <router-link to="/lost-password">Password dimenticata?</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      message: "",
    };
  },
  created() {
    this.$store.commit("stopLoading");
  },
  computed: {
    loading() {
      return this.$store.state.pending;
    },
  },
  methods: {
    login() {
      this.$store.commit("loading");
      this.$store
        .dispatch("login", {
          password: this.password,
          username: this.username,
        })
        .then((res) => {
          this.$store.commit("stopLoading");
          if (!res) {
            this.message = "";
          }
          if (res.success) {
            this.$router.push("/");
          }
          switch (res.code) {
            case -1:
              this.message = "Password errata o utente sconosciuto";
              break;
            case -2:
              this.message = "Licenza scaduta, contattare l'amministrazione";
              break;
            case -3:
              this.message = "Errore server";
              break;
            case -4:
              this.message = "Cliente non attivo";
              break;
          }
        })
        .catch((e) => {
          this.$store.commit("stopLoading");
          this.message = "Operazione non riuscita";
        });
    },
  },
};
</script>
<style scoped>
.logo img {
  height: 30px;
}
.auth {
  background: url("/static/bg.jpg") center center;
  background-size: cover;
}
.auth-title img {
  width: 300px;
}
.card.card-login {
  background: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.card.card-login input[type="text"],
.card.card-login input[type="password"] {
  background: transparent;
  color: #fff;
}
.form-control.no-border {
  border: 0;
}
#username {
  border: 1px solid #fff;
  border-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
#password {
  border: 1px solid #fff;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue